import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Bookmark } from "lucide-react";
import Seo from "../components/Seo";

const STYLES = ["Traditional","Neo-traditional","Japanese","Blackwork","Watercolor","Geometric","Realism","Minimalist"];

export default function Explore() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [style, setStyle] = useState("");
  const [savedIds, setSavedIds] = useState(new Set());

  useEffect(() => {
    api.get("/gallery", { params: style ? { style } : {} }).then((r) => setItems(r.data));
    if (user) api.get("/inspiration/mine").then((r) => setSavedIds(new Set(r.data.map((x) => x.id))));
  }, [style, user]);

  const toggleSave = async (id) => {
    if (!user) { toast.error("Sign in to save"); return; }
    try {
      const r = await api.post(`/inspiration/save/${id}`);
      const next = new Set(savedIds);
      if (r.data.saved) next.add(id); else next.delete(id);
      setSavedIds(next);
      toast.success(r.data.saved ? "Saved" : "Removed");
    } catch { toast.error("Could not save"); }
  };

  return (
    <div className="container-x py-12" data-testid="explore-page">
      <Seo title="Explore tattoo inspiration" description="Explore tattoo designs and portfolio work from artists around the world."/>
      <h1 className="font-serif text-4xl md:text-5xl">Explore</h1>
      <p className="text-black/60 mt-2">A daily mood board, by style.</p>
      <div className="mt-6 flex flex-wrap gap-2">
        <button onClick={()=>setStyle("")} className={`badge ${style===""?"badge-flash":"badge-neutral"}`} data-testid="style-all">All</button>
        {STYLES.map((s) => (
          <button key={s} onClick={()=>setStyle(s)} className={`badge ${style===s?"badge-flash":"badge-neutral"}`} data-testid={`style-${s.toLowerCase()}`}>{s}</button>
        ))}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mt-8">
        {items.map((p) => (
          <div key={p.id} className="card !p-0 overflow-hidden group relative" data-testid={`gallery-${p.id}`}>
            <div className="aspect-[3/4] overflow-hidden"><img src={p.image_url} alt={p.title} className="w-full h-full object-cover"/></div>
            <div className="p-3">
              <div className="text-sm font-medium truncate">{p.title}</div>
              <div className="flex items-center justify-between mt-1">
                {p.artist_username ? <Link to={`/artists/${p.artist_username}`} className="text-xs text-black/60 hover:text-black underline underline-offset-4">{p.artist_name}</Link> : <span className="text-xs text-black/60">{p.artist_name}</span>}
                <button onClick={()=>toggleSave(p.id)} aria-label="Save" data-testid={`save-${p.id}`} className="p-1">
                  <Bookmark size={16} fill={savedIds.has(p.id) ? "#000" : "none"}/>
                </button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-black/50 col-span-full">No pieces yet — artists, upload your work.</p>}
      </div>
    </div>
  );
}
